import {
    REQUEST_OUT,
    REQUEST_LOGIN,
    SET_STATE_SEARCHPARAMS,
    SET_SCREEN_INFO,
    SET_SELSTATIONINFO
} from '../../actions/common';

/**
 * initialState: 初始化state
 * @type {{userInfo: string}}
 * userInfo : 用户信息
 */
const initialState = {
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : '',
    searchArgs: {},
    screenInfo: {//大屏信息
      stationList: [], //电站列表
      stationName: '', //当前电站name
      stationId: '', //当前电站id
      alarmAndStationOnLineNum: {}, //告警信息
      stationStatistics: {}, //在线，离线信息
      clickStationId: '', //点击的电站
    }, 
    // 拖拽式工艺流程设置页，选择的厂站信息
    selStationInfo: sessionStorage.getItem('selStationInfo') ? JSON.parse(sessionStorage.getItem('selStationInfo')) : null,
};

const Index = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_LOGIN:
            return { ...state, userInfo: action.payload };
        case REQUEST_OUT:
            return { ...state, userInfo: '' };
        case SET_STATE_SEARCHPARAMS:
            return { ...state, searchArgs: action.payload };
        case SET_SCREEN_INFO:
            return { ...state, screenInfo: action.payload };
        case SET_SELSTATIONINFO:
            return { ...state, selStationInfo: action.payload };
        default:
            return state;
    }
}
export default Index




